import { easyLevels } from "./easy-levels";
import { mediumLevels } from "./medium-levels";
import { hardLevels } from "./hard-levels";

export const levels = [...easyLevels, ...mediumLevels, ...hardLevels];
